export default __webpack_public_path__ + "db8fd140327643bdb1b8096d641eb53d.png";